import React from 'react';

const OtherDetails = () => {
  return <div>OtherDetails</div>;
};

export default OtherDetails;
